import React,{Component} from 'react';

import './SubMenu.less';

class SubMenu extends Component{
  constructor(props){
    super(props);
    this.state = {
      active: props.menuItems[0],
      open: false,
    }
  }

  open = (e) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({open: true});

    document.addEventListener("click", this.close);
  }

  close = (e) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({open: false});

    document.removeEventListener("click", this.close);
  }



  trigger = (e,item) => {
    const {menuAction} = this.props;

    e.stopPropagation();
    e.preventDefault();

    document.removeEventListener("click", this.close);

    this.setState({
      open:false,
      active:item
    });

    if(typeof menuAction === 'function'){
      menuAction(item);
    }

  }



  render(){
    const {active,open,action} = this.state;
    const {menuItems} = this.props;
    return (
      <div className={open ? "submenu active" : "submenu"} onClick={open ? this.close : this.open}>
            <span className='submenu-active-item'>
              <span className="submenu-indicator"></span>
              {active}
            </span>
            {
              open &&
              <div className='submenu-items-container'>
                {
                  menuItems.filter(item => item != active).map((item,idx) => <div className='submenu-item' key={idx} onClick={e => this.trigger(e,item)}>{item}</div>)
                }
              </div>
            }
      </div>
    )
  }
}
export default SubMenu



// WEBPACK FOOTER //
// ./src/components/SubMenu.js